import { useMetadata } from '@/api/useMetadata'
import { SourceObjectCell, type SourceObjectCellProps, type SourceObjectDropdownProps } from './SourceObjectCell'
import { type RefSelectProps, Select } from 'antd'
import { useAddCellMapping } from './useAddCellMapping'
import { forwardRef } from 'react'
import { MappingDropdown } from '../MappingDropdown'

export const TerminalCell = (props: SourceObjectCellProps) => (
  <SourceObjectCell {...props} dropdown={TerminalCellDropdown} />
)

const TerminalCellDropdown = forwardRef<RefSelectProps, SourceObjectDropdownProps>(({ sourceSystem, value }, ref) => {
  const { data, isFetching, isPending } = useMetadata('bol')
  const onChange = useAddCellMapping('terminal', sourceSystem, value?.source_id)
  return (
    <MappingDropdown
      loading={isFetching || isPending}
      title='Add Terminal Mapping'
      subtitle='Select terminal to map to eBOL terminal'
      style={{ minWidth: '300px' }}
      optionFilterProp='label'
      onChange={onChange}
      ref={ref}
    >
      {[...new Set<string>(data?.locations ?? [])]
        .filter((x) => !value?.id_names?.some(({ name }) => name === x))
        .sort()
        .map((x: string) => (
          <Select.Option key={x} value={x} label={x}>
            {x}
          </Select.Option>
        ))}
    </MappingDropdown>
  )
})
